import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d3ae3992"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item-container" }
const _hoisted_2 = { id: "items" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["title", "id"]
const _hoisted_5 = { class: "item-thumbnails" }
const _hoisted_6 = ["src", "alt", "onClick"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "slider-container" }
const _hoisted_9 = ["onUpdate:modelValue", "onInput", "onKeyup"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_transition_expand = _resolveComponent("transition-expand")!

  return (_openBlock(), _createElementBlock("div", {
    class: "fv-root",
    style: _normalizeStyle(_ctx.cssVars)
  }, [
    _createVNode(_component_transition_expand, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.items !== null && _ctx.expanded)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(['bordered', 'item', _ctx.lastSelectedItem === item ? 'selected' : '']),
                      key: item.get_name(),
                      title: item.get_name(),
                      id: `fv-${item.get_name()}`
                    }, [
                      _createElementVNode("div", _hoisted_5, [
                        (_ctx.thumbnails)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: item.get_thumbnailUrl(),
                              alt: item.get_name(),
                              onClick: () => _ctx.selectItem(item)
                            }, null, 8, _hoisted_6))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", {
                          class: _normalizeClass(["item-name", ['thumbnail']]),
                          onClick: () => _ctx.selectItem(item)
                        }, _toDisplayString(item.get_name()), 9, _hoisted_7)
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        (_ctx.sliders)
                          ? _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 0,
                              type: "range",
                              "onUpdate:modelValue": ($event: any) => ((_ctx.opacities[item.get_name()]) = $event),
                              onInput: (e) => _ctx.onSliderInputChanged(e, item),
                              onKeyup: _withKeys(() => _ctx.selectItem(item), ["enter"]),
                              onMouseup: _cache[0] || (_cache[0] = () => { _ctx.lastOpacityChanged = null })
                            }, null, 40, _hoisted_9)), [
                              [_vModelText, _ctx.opacities[item.get_name()]]
                            ])
                          : _createCommentVNode("", true)
                      ])
                    ], 10, _hoisted_4))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    })
  ], 4))
}